export enum SegmentImage {
  personal_care = 'personal_care',
  fine_fragrance = 'fine_fragrance',
  home_care = 'home_care',
  fabric_care = 'fabric_care',
  air_freshener = 'air_care',
  oral_care = 'oral_care',
}
